module.exports = __webpack_public_path__ + "static/media/scroll-left-text2.f8152526.png";